export const CREATE_ALLOWANCE = "CREATE_ALLOWANCE";
export const FETCH_ALLOWANCES = "FETCH_ALLOWANCES";
export const FETCH_ALLOWANCE = "FETCH_ALLOWANCE";
export const EDIT_ALLOWANCE = "EDIT_ALLOWANCE";
export const DELETE_ALLOWANCE = "DELETE_ALLOWANCE";
// export const WHERE_ALLOWANCES = "WHERE_ALLOWANCES";
